import { Col, Modal, Row, Typography } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import "./style.css";
import Image from "next/image";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ISaveServiceRequestResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";
import { _eventBus } from "../../../core/events/EventBus";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";

const ServiceRequestModal: React.FC = () => {
  const intl = useIntl();

  const [saveServiceRequestResponse] = useRecState<ISaveServiceRequestResponse>(
    "saveServiceRequestResponseAtom"
  );
  const [isOpen] = useRecState<boolean>("serviceRequestModalAtom");

  const onClose = () => {
    _eventBus.emit({
      eventName: srReqClaimTree.RequestClaim.SuccessModal,
      data: false,
    });
  };

  return (
    <Modal
      width={"452px"}
      title={null}
      open={isOpen}
      footer={null}
      onCancel={onClose}
      className="service-request-modal"
      mask={{ closable: false }}
    >
      <Row className="p-10">
        <Col span={24} className="justify-content-center">
          <Image
            src="/assets/checkout/paymentSuccess.gif"
            height={150}
            width={150}
            alt="service request success"
          />
        </Col>
        <Col span={24} className="justify-content-center">
          <Typography.Text className="fs-24 fw-700 ff-inter">
            {intl.formatMessage({ id: "requestSubmitText" })}
          </Typography.Text>
        </Col>
        <Col span={24} className="justify-content-center">
          <Typography.Text className="fs-15 fw-600 ff-inter color-757575 mt-5">
            {intl.formatMessage({ id: "requestIdIsText" })}{" "}
            {saveServiceRequestResponse?.id || ""}
          </Typography.Text>
        </Col>
        <Col span={24} className="justify-content-center text-center">
          <Typography.Text className="fs-16 fw-400 ff-inter color-757575 mt-20">
            {intl.formatMessage({ id: "ourTeamWillEnsureText" })}
          </Typography.Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default ServiceRequestModal;
